import React from 'react';
import { motion } from 'framer-motion';
export function Problem() {
  return <section className="problem" data-id="element-122">
      <motion.div className="container" initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-40px'
    }} transition={{
      duration: 0.8
    }} data-id="element-123">
        <span className="section-tag" data-id="element-124">El Problema</span>
        <h2 data-id="element-125">
          Tu negocio necesita una página web. Y cada día sin ella, pierdes
          dinero.
        </h2>
        <p data-id="element-126">
          Llevas meses mandando gente a tu Instagram porque no tienes una página
          web. Cada vez que alguien te pregunta{' '}
          <strong data-id="element-127">"¿tienes sitio web?"</strong> cambias el tema.
        </p>
        <p data-id="element-128">
          Ya cotizaste con diseñadores. Te pidieron{' '}
          <strong data-id="element-129">$2,000 a $5,000 dólares</strong> y tardan de 6 a 12 semanas.
          Todo eso para algo que después tú no puedes ni editar sin llamarlos.
        </p>
        <p data-id="element-130">
          Intentaste hacerla tú en Wix o WordPress. Pero te perdiste entre
          plugins, templates genéricos y configuraciones infinitas. Y la dejaste
          a medias.
        </p>
        <p className="kicker" data-id="element-131">
          Tu competencia sí tiene página. Y se está quedando con los clientes
          que deberían ser tuyos.
        </p>
      </motion.div>
    </section>;
}